(function () {
  function initFeatured() {
    if (typeof Swiper === 'undefined') {
      return window.setTimeout(initFeatured, 50);
    }

    document.querySelectorAll('.ctr-featured__carousel').forEach(function (carousel) {
      if (carousel.dataset.ctrInit) return;
      carousel.dataset.ctrInit = '1';

      var section = carousel.closest('.ctr-featured');
      var dots = section ? section.querySelector('.ctr-featured__dots') : null;
      var sparkle = carousel.dataset.sparkle || '';

      new Swiper(carousel, {
        slidesPerView: 2.1,
        spaceBetween: 16,
        watchOverflow: true,
        grabCursor: true,
        breakpoints: {
          750: { slidesPerView: 3.2, spaceBetween: 16 },
          1200: { slidesPerView: 4.2, spaceBetween: 22 }
        },
        pagination: dots
          ? {
              el: dots,
              clickable: true,
              renderBullet: function (index, className) {
                return '<span class="' + className + '">' + sparkle + '</span>';
              }
            }
          : false
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFeatured);
  } else {
    initFeatured();
  }
})();
